import _ from 'lodash';
import { constants } from '../constants/index.js';
import {
    triggerLoginOverlayEvent,
	triggerRegisterOverlayEvent,
    subscribeToMaterialBoxOpened,
	subscribeToMaterialBoxClosed,
	subscribeToUserLoginSuccess
} from '../services/postal.js';

const { SSO_WRAPPER_ID } = constants;

const handleMaterialBoxSubscribeBeforeClosing = (materialBoxOpenedSubscription, materialBoxInstance) => {
	if (materialBoxOpenedSubscription) {
		const materialBoxContentSSO = _.find(materialBoxInstance?.content, content => content?.id === SSO_WRAPPER_ID);

		if (materialBoxContentSSO) {
			materialBoxInstance && materialBoxInstance.close();
			materialBoxOpenedSubscription.unsubscribe();
		}
	}
};

function subscribeToLoginSuccess (resolve, materialBoxOpenedSubscription, materialBoxInstance, setCustomerProfile, setUserToken, setIsUserLoggedIn) {
    subscribeToUserLoginSuccess(data => {
		const userData = data.userData;

		setCustomerProfile(userData.customerProfile); 
		setUserToken(userData.token);
		setIsUserLoggedIn(true);
		handleMaterialBoxSubscribeBeforeClosing(materialBoxOpenedSubscription, materialBoxInstance);
		
		return resolve(userData);
	});
}

const login = (setCustomerProfile, setUserToken, setIsUserLoggedIn) => {
	return new Promise(resolve => {

		const materialBoxOpenedSubscription = subscribeToMaterialBoxOpened(instance => {
			subscribeToLoginSuccess(resolve, materialBoxOpenedSubscription, instance, setCustomerProfile, setUserToken, setIsUserLoggedIn);
			materialBoxOpenedSubscription.unsubscribe();
		});

		const subscribeCloseInstance = subscribeToMaterialBoxClosed(materialBoxInstance => {
			if (materialBoxInstance) {
				handleMaterialBoxSubscribeBeforeClosing(materialBoxOpenedSubscription, materialBoxInstance);
			}
			subscribeCloseInstance.unsubscribe();
		}); 
	
		triggerLoginOverlayEvent()
	});   
}

const register = () => {
	triggerRegisterOverlayEvent()
}

export {
    login,
	register
}